import { useMemo } from 'react';
import { Chart } from 'react-chartjs-2';
import { AutoSizer, Size } from 'react-virtualized';
import { selectSettings } from 'ducks/settings/selectors';
import { useAppSelector } from 'store/hooks';
import { getNavigatorData, navigator_options } from 'utils/charts';

import { Card } from 'components/cards/Card';
import { RangeSelector } from 'components/range/NavigatorRange';

import 'chartjs-adapter-moment';

import { CANDLE_WINDOW, EMPTY_FUNCTION } from '../../../constants';

import { NavigatorGraphProps } from './types';

import cn from './Graph.module.scss';

export const NavigatorGraph = ({
  candles,
  visible,
  setVisible = EMPTY_FUNCTION,
}: NavigatorGraphProps) => {
  const { loading_component } = useAppSelector(selectSettings);
  const navigator = getNavigatorData({ data: candles });
  const navigator_datasets = { datasets: [navigator] };

  const timeseries = useMemo(() => {
    if (candles.length === 0) {
      return { min: 0, max: CANDLE_WINDOW };
    }
    return { min: candles[0].x, max: candles[candles.length - 1].x };
  }, [candles]);

  return (
    <Card loading={loading_component} direction="column" minHeight="100px" maxHeight="15%">
      <AutoSizer>
        {({ height, width }: Size) => (
          <div className={cn.graph} style={{ height, width }}>
            <RangeSelector
              min={timeseries.min}
              max={timeseries.max}
              start={visible.start}
              end={visible.end}
              onChange={setVisible}
            />
            <Chart
              key="navigator"
              type="line"
              data={navigator_datasets}
              options={navigator_options}
              width={width}
              height={height}
            />
          </div>
        )}
      </AutoSizer>
    </Card>
  );
};
